<template>
    <div class="footer">
        <div class="footerTop">
            <div class="top">
                <div class="topImg">
                    <img src="../../styles/images/ysy/logoysys.png" alt="">
                </div>
                <div class="footerTxt">
                <p>电话：{{companyInfo.phone}}</p>
                <p>邮箱：{{companyInfo.email}}</p>
                <p>地址：{{companyInfo.address}}</p>
                <!-- <p>鄂ICP备18007135号-1   湖北有所依科技有限公司</p> -->
            </div>
            </div>
            <div class="footerIcon">
                <!-- <img src="../../styles/images/ysy/ewm.png" alt=""> -->
            </div>
        </div>
        
        <div class="line"></div>
        <div class="name">
            <div>{{companyInfo.name}}</div>
        </div>
        <div class="other">
            <div> Copyright © 2018 鄂ICP备18007135号-1</div>
        </div>
    </div>
</template>
<script>
import { getCompanyInfo} from "@/api/manage";
export default {
    data(){
        return{
         companyInfo:''
        } 
    },
     created(){
      this.getData()
    },
    methods:{
        async getData(){
        let res = await getCompanyInfo()
        this.companyInfo = res.data
    }
    }
}
</script>
<style scoped>
.footer{
    background-color: #3F4342;
    height: 301px;
    box-sizing: border-box;
    overflow: hidden;
    min-width: 1300px;
}
.footerTop{
    width: 1200px;
    margin:0 auto;
    display: flex;
    position: relative;
    justify-content: space-between;
}
.top{
    display: flex;
    padding:58px 0 0 0;
    height: 95px;
}
.topImg{
    padding-top: 20px;
    margin-right: 30px;
}
.topImg img{
    width: 79px;
    height: 58px;
}
.footerIcon{
    padding-top: 40px;
    width: 132px;
    height: 130px;
}
.footerIcon img {
    width: 100%;
    height: 100%;
}
.footerTxt{
    width: 453px;
    height: 95px;
    font-size: 15px;
    color: #fff;
    display: flex;
    flex-direction:column;
    justify-content: space-between;
}
.footerTxt p{
    margin:0;
}
.line{
    width: 100%;
    height: 2px;
    margin-top: 58px;
    background: url('../../styles/images/newImages/foot_line.png');
}
.name,.other{
    margin-top: 19px;
    position: relative;
    height: 17px;
}
.name{
    font-weight: 700;
    color: white;
}
.footer .other{
    font-size: 14px;
    color: white;
    margin-top: 14px;
}
.name div,.other div{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    font-size: 14px;
}
.other div{
    font-size: 12px;
    font-style: normal;
}
</style>